import { EChannel } from 'core/model/enums/channel.enum';

interface IChannelContact {
  email: string;
  phone: string;
  whatsapp: string;
  messageWsp: string;
  facebook?: string;
  instagram?: string;
  youtube?: string;
  signUp: string;
}

export const CHANNEL_CONTACTS: Record<EChannel, IChannelContact> = {
  [EChannel.DIADIA]: {
    email: 'atencionclientes@alicorp.com.pe',
    phone: '938371007',
    whatsapp: '+51938371007',
    messageWsp: 'Hola, tengo unas dudas y consultas. ¿Podrías ayudarme? 🙂',
    facebook: 'https://www.facebook.com/alicorpoficial/',
    signUp: 'https://www.insuma.com.pe/',
  },
  [EChannel.INSUMA]: {
    email: 'atencionclientes@alicorp.com.pe',
    phone: '945537324',
    whatsapp: '+51945537324',
    messageWsp: 'Hola, tengo unas dudas y consultas. ¿Podrías ayudarme? 🙂',
    facebook: 'https://www.facebook.com/InsumaPeru/',
    instagram: 'https://www.instagram.com/insumaperu/',
    youtube: 'https://youtube.com/@insuma4852?si=xRdQmL_RQqcH_o7b',
    signUp: 'https://www.insuma.com.pe/',
  },
  [EChannel.ALICORP]: {
    email: 'atencionclientes@alicorp.com.pe',
    phone: '938371007',
    whatsapp: '+51938371007',
    messageWsp: 'Hola, tengo unas dudas y consultas. ¿Podrías ayudarme? 🙂',
    facebook: 'https://www.facebook.com/alicorpoficial/',
    instagram: 'https://www.instagram.com/insumaperu/',
    youtube: 'https://youtube.com/@insuma4852?si=xRdQmL_RQqcH_o7b',
    signUp: 'https://www.insuma.com.pe/',
  },
};

export const COMPANY_DATA = {
  BUSINESSNAME: 'APUDEX S.A.C.',
  RUC: '20602893350',
  PHONE: '976712178',
  NAME: 'Jeremy Miranda',
  EMAIL: 'atencioncobranzas@pu.com.pe',
};
